// src/hooks/useIsAdmin.ts
// Az admin jogot NEM a Clerk, hanem a backend/adatbázis (admin_users tábla) dönti el.
// A frontend csak megkérdezi a backendet a Clerk munkamenet-tokennel.
import { useEffect, useState } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";

const API_BASE = process.env.REACT_APP_API_URL ?? "";

// A Navbar minden oldalváltásnál újra létrejön, ezért felhasználónként megjegyezzük az eredményt
const cache = new Map<string, boolean>();

export function useIsAdmin() {
    const { isLoaded, isSignedIn, getToken } = useAuth();
    const { user } = useUser();
    const userId = user?.id ?? null;

    const [isAdmin, setIsAdmin] = useState<boolean>(userId ? cache.get(userId) ?? false : false);
    const [checked, setChecked] = useState<boolean>(userId ? cache.has(userId) : false);

    useEffect(() => {
        if (!isLoaded) return;

        if (!isSignedIn || !userId) {
            setIsAdmin(false);
            setChecked(true);
            return;
        }

        if (cache.has(userId)) {
            setIsAdmin(cache.get(userId) as boolean);
            setChecked(true);
            return;
        }

        let cancelled = false;
        (async () => {
            let admin = false;
            try {
                const token = await getToken();
                const res = await fetch(`${API_BASE}/api/user/admin-status`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (res.ok) {
                    const data = await res.json();
                    admin = data?.admin === true;
                    cache.set(userId, admin); // csak sikeres válasznál jegyezzük meg
                }
            } catch (error) {
                console.error("Admin státusz lekérdezése sikertelen:", error);
            }
            if (!cancelled) {
                setIsAdmin(admin);
                setChecked(true);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [isLoaded, isSignedIn, userId, getToken]);

    return { isAdmin, checked };
}